// FAQ expand/collapse functionality
function initializeFAQ() {
    const faqButtons = document.querySelectorAll('.faq-button');
    
    faqButtons.forEach(function(button) {
        // Remove existing listeners to prevent duplicates
        button.replaceWith(button.cloneNode(true));
    });
    
    // Re-select after cloning
    const newFaqButtons = document.querySelectorAll('.faq-button');
    
    newFaqButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const answer = button.parentElement.nextElementSibling;
            const plusIcon = button.querySelector('.faq-icon-plus');
            const minusIcon = button.querySelector('.faq-icon-minus');
            
            // Close all other FAQs first
            newFaqButtons.forEach(function(otherButton) {
                if (otherButton !== button) {
                    const otherAnswer = otherButton.parentElement.nextElementSibling;
                    const otherPlusIcon = otherButton.querySelector('.faq-icon-plus');
                    const otherMinusIcon = otherButton.querySelector('.faq-icon-minus');
                    
                    otherButton.setAttribute('aria-expanded', 'false');
                    otherAnswer.classList.add('hidden');
                    otherPlusIcon.classList.remove('hidden');
                    otherMinusIcon.classList.add('hidden');
                }
            });
            
            // Toggle current FAQ
            button.setAttribute('aria-expanded', !isExpanded);
            
            if (isExpanded) {
                answer.classList.add('hidden');
                plusIcon.classList.remove('hidden');
                minusIcon.classList.add('hidden');
            } else {
                answer.classList.remove('hidden');
                plusIcon.classList.add('hidden');
                minusIcon.classList.remove('hidden');
            }
        });
    });
}

// Initialize FAQ on page load and Turbo page changes
document.addEventListener('DOMContentLoaded', initializeFAQ);
document.addEventListener('turbo:load', initializeFAQ);

document.addEventListener('DOMContentLoaded', function() {
    // Burger menus
    // open
    const burger = document.querySelectorAll('.navbar-burger');
    const menu = document.querySelectorAll('.navbar-menu');

    if (burger.length && menu.length) {
        for (var i = 0; i < burger.length; i++) {
            burger[i].addEventListener('click', function() {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle('hidden');
                }
            });
        }
    }

    // close
    const close = document.querySelectorAll('.navbar-close');
    const backdrop = document.querySelectorAll('.navbar-backdrop');

    if (close.length) {
        for (var i = 0; i < close.length; i++) {
            close[i].addEventListener('click', function() {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle('hidden');
                }
            });
        }
    }

    if (backdrop.length) {
        for (var i = 0; i < backdrop.length; i++) {
            backdrop[i].addEventListener('click', function() {
                for (var j = 0; j < menu.length; j++) {
                    menu[j].classList.toggle('hidden');
                }
            });
        }
    }
});
